/**
 * Format the current date in short date
 * @param {DateTime} date
 * @param {string} countryCode
 * @returns short date
 */
export const formattingDate = (date, countryCode) => {
  const newDate = new Date(date);
  const defaultCountryCode = countryCode ? countryCode : 'fr-FR';
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'UTC',
  };
  return new Intl.DateTimeFormat(defaultCountryCode, options).format(newDate);
};

/**
 * format the current date in long date
 * @param {DateTime} date
 * @param {string} countryCode
 * @returns string format for date time
 */
export const formattingDateString = (date, countryCode) => {
  const newDate = new Date(date);
  const options = {
    month: 'long',
    weekday: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  };
  const defaultCountryCode = countryCode ? countryCode : 'fr-FR';
  return new Intl.DateTimeFormat(defaultCountryCode, options).format(newDate);
};

/**
 * format the current date in short time (HH:mm)
 * @param {DateTime} date
 * @param {string} countryCode
 * @returns time HH:mm
 */
export const formattingTimeWithoutSeconde = (date, countryCode) => {
  const newDate = new Date(date);
  const defaultCountryCode = countryCode ? countryCode : 'fr-FR';

  return newDate.toLocaleTimeString(
    [defaultCountryCode] /* {
    timeStyle: 'short',
  } */,
    {
      hour: '2-digit',
      minute: '2-digit',
    },
  );
};
